(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3898],{

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ }),

/***/ 83019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59499);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50029);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68777);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _api_redux_termscondition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19371);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31555);
/* harmony import */ var _components_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93264);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68312);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25317);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30653);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2962);
/* harmony import */ var _api_store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38584);
/* harmony import */ var _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92495);
/* harmony import */ var _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11267);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);






















var TermsandCondition = function TermsandCondition(_ref) {
  var _getPost$posts, _getPost$posts$data, _getPost$posts2, _getPost$posts3, _getPost$posts3$data, _getPost$posts3$data$, _getPost$posts4, _getPost$posts4$data, _getPost$posts4$data$, _banner$images, _banner$images$list, _banner$images$list$, _banner$images2, _banner$images2$list, _banner$images2$list$;

  var offset = _ref.offset;
  var getPost = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.termsConditonReducer;
  });
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data;
  var load_list = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts2 = getPost.posts) === null || _getPost$posts2 === void 0 ? void 0 : _getPost$posts2.download_list;
  var download_cta = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts3 = getPost.posts) === null || _getPost$posts3 === void 0 ? void 0 : (_getPost$posts3$data = _getPost$posts3.data) === null || _getPost$posts3$data === void 0 ? void 0 : (_getPost$posts3$data$ = _getPost$posts3$data.sections) === null || _getPost$posts3$data$ === void 0 ? void 0 : _getPost$posts3$data$.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'downloads-cta';
  });
  var banner = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts4 = getPost.posts) === null || _getPost$posts4 === void 0 ? void 0 : (_getPost$posts4$data = _getPost$posts4.data) === null || _getPost$posts4$data === void 0 ? void 0 : (_getPost$posts4$data$ = _getPost$posts4$data.sections) === null || _getPost$posts4$data$ === void 0 ? void 0 : _getPost$posts4$data$.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'banner-about';
  }); // for 404 page

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setTimeout(function () {
      var tl = new gsap__WEBPACK_IMPORTED_MODULE_12__/* .TimelineLite */ .Vq();
      tl.to('.page-transition', {
        delay: 1,
        opacity: 0,
        duration: 1,
        display: 'none'
      }).to('.page-transition .logo', {
        duration: .6,
        opacity: 0
      }, '-=.6');
    }, 1500);
    gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_13__.ScrollTrigger.refresh(); // Scroll to top when page changes

    window.scrollTo(0, 0);
  }, [getPost]);
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
  var currentUrl = router && router.asPath;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_13__.ScrollTrigger.refresh(); // Scroll to top when page changes

    window.scrollTo(0, 0);
  }, [router]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_6__/* .NextSeo */ .PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (0,react_html_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited'),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrl,
      openGraph: {
        type: 'website',
        url: "https://www.shantasecurities.com" + currentUrl,
        title: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(page_data === null || page_data === void 0 ? void 0 : page_data.og_title),
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: banner === null || banner === void 0 ? void 0 : (_banner$images = banner.images) === null || _banner$images === void 0 ? void 0 : (_banner$images$list = _banner$images.list) === null || _banner$images$list === void 0 ? void 0 : (_banner$images$list$ = _banner$images$list[0]) === null || _banner$images$list$ === void 0 ? void 0 : _banner$images$list$.full_path,
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: banner === null || banner === void 0 ? void 0 : (_banner$images2 = banner.images) === null || _banner$images2 === void 0 ? void 0 : (_banner$images2$list = _banner$images2.list) === null || _banner$images2$list === void 0 ? void 0 : (_banner$images2$list$ = _banner$images2$list[0]) === null || _banner$images2$list$ === void 0 ? void 0 : _banner$images2$list$.full_path,
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(StyledComponent, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            md: 12,
            className: " pt-200 pb-200",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_Title__WEBPACK_IMPORTED_MODULE_4__["default"], {
              noanim: true,
              text: 'Terms and Conditions',
              fontSize: '44',
              fontWeight: '400',
              margin: '0 0 40px',
              lineHeight: '56'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "content",
              children: page_data !== null && page_data !== void 0 && page_data.description ? (0,react_html_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(page_data === null || page_data === void 0 ? void 0 : page_data.description) : (0,react_html_parser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)('<p> These terms and conditions ("Terms") govern the use of financial securities services provided by Shanta Securities Limited to its clients. By engaging our services, you agree to abide by these Terms. Please read them carefully. </p><br><br><h6> 1. Definitions</h6><br><ul><li> 1.1 "Company" refers to Shanta Securities Limited, a Brokerage company registered in Bangladesh.</li><li> 1.2 "Client" refers to the individual or entity engaging the services of the Company.</li></ul><br><br><h6> 2. Services</h6><br><ul><li>2.1 The Company agrees to provide  brokerage services to the clients. </li><li>2.2 The client acknowledges that investment in securities carries inherent risks, and the Company does not guarantee profits or protection against losses.</li></ul><br><br><h6> 3. Client Responsibilities </h6><br><ul><li>3.1 The client shall adhere to all relevant laws and regulations governing financial transactions in Bangladesh. </li></ul><br><br><h6>4. Confidentiality and Data Protection </h6><br><ul><li>4.1 The Company shall maintain the confidentiality of client information in compliance with applicable data protection laws in Bangladesh.</li></ul><br><br><h6>5. Risk Disclosure </h6><br><ul><li>5.1  The client acknowledges and understands the risks associated with securities transactions and investments.</li><li>5.2  The Company shall provide periodic updates to the client.</li></ul><br><br><h6>6. Fees and Charges </h6><br><ul><li>6.1 The client agrees to pay fees and charges for the  brokerage services as  per mutual agreement.</li><li>6.2 The Company reserves the right to revise fees and charges upon providing reasonable notice to the client.</li></ul><br><br><h6>7. Compliance with Laws </h6><br><ul><li>7.1 Both parties shall comply with all applicable laws and regulations in Bangladesh related to securities brokerage.</li></ul><br><br><h6>8. Termination </h6><br><ul><li>8.1 Either party may terminate the service agreement in accordance with the terms specified in the account opening form.</li></ul><br><br><h6>9. Governing Law </h6><br><ul><li>9.1 These Terms shall be governed by and construed in accordance with the laws of Bangladesh.</li></ul><br><br><br>')
            })]
          })
        })
      })
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "terms-conditions__StyledComponent",
  componentId: "sc-17mcooc-0"
})(["min-height:80vh;a{color:", ";}ul,ol{li{padding-left:20px;position:relative;margin-bottom:20px;&:last-child{margin-bottom:0;}&:after{height:10px;width:10px;background:", ";content:'';position:absolute;left:0;top:5px;border-radius:50%;}}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__/* .hover */ .Mr);
TermsandCondition.getInitialProps = _api_store__WEBPACK_IMPORTED_MODULE_7__/* .wrapper.getInitialPageProps */ .YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _param;

    var api_services, param;
    return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api_services = _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_8__/* .ApiServices.SECTIONS */ .u.SECTIONS;
            param = (_param = {}, (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.TYPE */ .j.TYPE, 'slug'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.VALUE */ .j.VALUE, 'terms-conditions'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.GET_SECTION */ .j.GET_SECTION, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.IMAGE */ .j.IMAGE, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.POST */ .j.POST, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_9__/* .ApiParamKey.GALLERY */ .j.GALLERY, 'yes'), _param);
            _context.next = 4;
            return store.dispatch((0,_api_redux_termscondition__WEBPACK_IMPORTED_MODULE_3__/* .fetchPosts */ .T)([api_services, param]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
/* harmony default export */ __webpack_exports__["default"] = (TermsandCondition);

/***/ }),

/***/ 94925:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-conditions",
      function () {
        return __webpack_require__(83019);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(94925); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);